import { IColumn, Stack, Text } from '@fluentui/react';
import clsx from 'clsx';
import { DataAccessPolicyRow } from '.';
import { DataAccessPolicyModal } from '../view';

export type ColumnStylesProps = {
  onRenderColumnStack: string;
  dataAccessPolicyCol: string;
};

export const onRenderItems = (styles: ColumnStylesProps) => {
  const renderItemColumn = (
    item: DataAccessPolicyRow | undefined,
    _index: number | undefined,
    column: IColumn | undefined
  ) => {
    if (item) {
      const fieldContent = item[
        column?.fieldName as keyof DataAccessPolicyRow
      ] as string;
      switch (column?.key) {
        case 'name':
          return (
            <Stack
              verticalAlign="center"
              className={clsx(
                styles.dataAccessPolicyCol,
                styles.onRenderColumnStack
              )}
            >
              <Text>{fieldContent}</Text>
            </Stack>
          );
        case 'action':
          return (
            <Stack
              horizontal
              verticalAlign="center"
              tokens={{ childrenGap: 3 }}
            >
              <DataAccessPolicyModal existingDataAccessPolicy={item} />
            </Stack>
          );
        default:
          return (
            <Stack
              verticalAlign="center"
              className={styles.onRenderColumnStack}
            >
              <Text>{fieldContent}</Text>
            </Stack>
          );
      }
    }
  };
  return renderItemColumn;
};
